module.exports = __webpack_public_path__ + "media/src/Quiz/sandbox/questionLandscape-4c2d47b00fca644a776eee80356acdb0.jpg";